import { FormLabel, InputGroup } from "react-bootstrap";
import InputGroupText from "react-bootstrap/esm/InputGroupText";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCalendar } from "@fortawesome/free-regular-svg-icons";
import DatePicker from "react-datepicker";
import 'react-datepicker/dist/react-datepicker.css';
import { useEffect, useRef, useState } from "react";


interface IDateSelector {
  name?: string;
  id?: string;
  onDateSelected?: (event: React.ChangeEvent<HTMLInputElement>) => void;
  value?: Date | null;
  dateFormat?: string;
  placeHolder?: string;
  showTimeSelect?: boolean;
  showTimeInput?: boolean;
  startDate?: Date;
  todayButton?: string;
}

const DateSelector = (props: IDateSelector) => {

  const [selectedDate, setSelectedDate] = useState<Date | null>(null);
  const pickerRef = useRef<DatePicker>(null);

  const onInputChange = (selected: Date | null) : void => {
    if (props.onDateSelected) {
      const evt = {
        target: {
          name: props.name ?? "dateSelect",
          value: selected ? selected.toISOString() : ""
        }
      } as React.ChangeEvent<HTMLInputElement>;

      props.onDateSelected(evt);
      setSelectedDate(selected);
    }
  }

  const handleDateChange = (
    selected: Date | null,
    event?: React.MouseEvent<HTMLElement> | React.KeyboardEvent<HTMLElement>
  ): void => {
    onInputChange(selected);

    if (!props.todayButton) {
      return;
    }

    const target = event?.target;
    const fromToday = target instanceof Element && Boolean(target.closest(".react-datepicker__today-button"));
    if (!fromToday) {
      pickerRef.current?.setOpen(false);
    }
  }

  useEffect(() => {
    if (props.value) {
      const dt = new Date(props.value);
      if (dt) {
        setSelectedDate(dt);
      }
    }
  }, [props])

  return (
    <>
      <InputGroup className="w-100">
        <InputGroupText>
          <FontAwesomeIcon icon={faCalendar} />
        </InputGroupText>
        <DatePicker
          ref={pickerRef}
          onChange={handleDateChange}
          dateFormat={ props.dateFormat ?? "dd-MM-yyyy" }
          placeholderText={props.placeHolder ?? "select date..."}
          selected={selectedDate}
          showTimeSelect={props.showTimeSelect ?? false}
          showTimeInput={props.showTimeInput ?? false}
          wrapperClassName="flex-grow-1"
          minDate={props.startDate}
          todayButton={props.todayButton}
          shouldCloseOnSelect={!props.todayButton}
          className="form-control w-100 rounded-0 rounded-end">
        </DatePicker>
      </InputGroup>
    </>
  );
}

export default DateSelector;